<template>
  <el-dialog custom-class="medium-dialog" :title="title" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="门店：" :label-width="formLabelWidth" prop="customerserial">
            <el-col :span="14"><span  style="cursor: pointer;"  @click="clearCustomer">{{form.customername}}</span></el-col>
            <el-col :span="6"> 编码：{{form.customerserial}}</el-col>
            <el-col :span="4"><el-checkbox v-model="notContainChild" @change="bindData">不包含下级门店</el-checkbox></el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="childCustomerList.length>0">
        <el-col :span="24">
          <el-form-item label="下级门店：" :label-width="formLabelWidth">
            <p v-for="item in childCustomerList"><span style="cursor: pointer;" @click="afterSelExternalDept(item.customerserial,item.deptname,item)">{{item.deptname}}</span></p>
          </el-form-item>
        </el-col></el-row>
      <el-row :gutter="20">
        <el-col :span="14">
          <el-form-item label="进度：" :label-width="formLabelWidth" >
            <el-progress :text-inside="true" :stroke-width="25" :percentage="percentage" status="success"></el-progress>
          </el-form-item>
          <el-form-item label="备注：" :label-width="formLabelWidth" prop="remark">
            {{form.remark}}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="" :label-width="formLabelWidth" prop="remark">
            <div style="line-height: 20px;">
              <p><span class="lefttitle">合同日期</span>：<span>{{form.htqd.substring(0,10)+'~'+form.jhjgrq.substring(0,10)}}</span></p>
              <p><span class="lefttitle">合同总额</span>：<span class="rightinfo">{{form.htje|numeric(2,1)}}</span>
              </p>
              <p><span class="lefttitle">可返金额</span>：<span class="rightinfo">{{canRebateMoney|numeric(2,1)}}</span></p>
              <p><span class="lefttitle">已&nbsp;完&nbsp;&nbsp;成</span>：<span class="rightinfo">{{haveFinishMoney|numeric(2,1)}}</span><span
                style="cursor:pointer;color:orangered;" @click="calculateNewMoney" title="计算差价">差价</span><span
                style="cursor:pointer;" @click="showRecordList">{{form.discount|numeric(2,1)}}</span>
              </p>
              <p style="color:#ff3a8f;"><span class="lefttitle">应&nbsp;完&nbsp;&nbsp;成</span>：<span class="rightinfo">{{needFinishMoney|numeric(2,1)}}</span>
              </p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-collapse v-model="activeNames">

        <el-collapse-item name="1">
          <template slot="title" style="display: inline-block;">
        <span class="titlecolor">合同明细&nbsp;&nbsp;(<span style="color:red;">注：合同明细中销售总额不包含特价商品的销售额</span>)
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;"
            >
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{scope.row.categoryname=='合计'?"": 1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="170"
              >
                <template slot-scope="scope">
                  {{
                  !scope.row.seedcode?((scope.row.categorycode||"")+''+scope.row.categoryname):scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center"
              >
              </el-table-column>
              <el-table-column label="下单方式" align="center" width="85">
                <template slot-scope="scope">
                  {{getFilltemplate(scope.row.filltemplate)}}
                </template>
              </el-table-column>
              <el-table-column label="返利点" align="center" width="60" prop="rebatepercent">
              </el-table-column>
              <el-table-column label="销售额" align="right" header-align="center" width="80">
                <template slot-scope="scope">
                  {{scope.row.totalmoneytax|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column label="可返还金额" align="right" header-align="center" width="85">
                <template slot-scope="scope">
                  {{scope.row.rebatemoney|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column label="订单明细" align="center" width="70">
                <template slot-scope="scope">
                  <el-button
                    size="mini" v-if="scope.row.categoryname!='合计'"
                    @click="handleViewOrder(scope.$index, scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>

        <el-collapse-item name="2">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor">特价产品
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableDataSkim"
              size="mini"
              stripe
              border
              style="width: 100%;"
            >
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{scope.row.categoryname=='合计'?"": 1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="170"
              >
                <template slot-scope="scope">
                  {{scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center"
              >
              </el-table-column>
              <el-table-column label="计入合同额" align="center" width="85">
                <template slot-scope="scope">
                  {{scope.row.categoryname=='合计'?"": scope.row.iscontractmoney==1?"是":"否"}}
                </template>
              </el-table-column>
              <el-table-column label="返利点" align="center" width="60" prop="rebatepercent">
              </el-table-column>
              <el-table-column label="销售额" align="right" header-align="center" width="80">
                <template slot-scope="scope">
                  {{scope.row.totalmoneytax|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column label="可返还金额" align="right" header-align="center" width="85">
                <template slot-scope="scope">
                  {{scope.row.rebatemoney|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column label="订单明细" align="center" width="70">
                <template slot-scope="scope">
                  <el-button
                    size="mini" v-if="scope.row.categoryname!='合计'"
                    @click="handleViewOrder(scope.$index, scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>

        <el-collapse-item name="3" v-if="!form.parenterpserial">
          <template slot="title" style="display: inline-block;">
        <span class="titlecolor">子合同
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableDataChild"
              size="mini"
              stripe
              border
              style="width: 100%;"
            >
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{scope.row.pname=='合计'?"": 1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="pname"
                label="合同名称" :show-overflow-tooltip="true"
                align="left"
                header-align="center"
              >
              </el-table-column>
              <el-table-column label="计入主合同额" align="center" width="95">
                <template slot-scope="scope">
                  {{scope.row.pname=='合计'?"":scope.row.returntype==1?"是":"否"}}
                </template>
              </el-table-column>
              <el-table-column label="返点" align="center" width="60" prop="rebatepercent">
                <template slot-scope="scope">
                  {{scope.row.pname=='合计'?"":'是'}}
                </template>
              </el-table-column>
              <el-table-column label="销售额" align="right" header-align="center" width="80">
                <template slot-scope="scope">
                  {{scope.row.yfk|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column label="可返还金额" align="right" header-align="center" width="85">
                <template slot-scope="scope">
                  {{scope.row.htje|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column label="合同明细" align="center" width="70">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.pname!='合计'"
                             size="mini"
                             @click="handleViewChildContract(scope.$index, scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>

      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
    <SaleContractEdit ref="SaleContractEdit"></SaleContractEdit>
    <StoreDetailListSeedSee ref="StoreDetailListSeedSee"></StoreDetailListSeedSee>
    <DiffRecordList ref="DiffRecordList"></DiffRecordList>
  </el-dialog>
</template>

<script>
  import {getTJByUnitGuid, calculateNewMoney} from '@/api/order/salecontract';
  import SaleContractEdit from './SaleContractEdit';
  import StoreDetailListSeedSee from '@/components/account/StoreDetailListSeedSee';
  import DiffRecordList from './DiffRecordList';
  import {getListData} from '@/api/set/externaldept';

  export default {
    name: 'HelloWorld',
    data() {
      return {
        dialogFormVisible: false,
        title: '',
        activeNames: ['1', '2', '3'],
        tableData: [],
        tableDataSkim: [],//撇除的产品
        tableDataChild: [],//子合同
        formLabelWidth: '120px',
        canRebateMoney: 0,//可返现金额
        haveFinishMoney: 0,//已完成
        needFinishMoney: 0,//应完成
        percentage: 0,
        customername: "",//下级门店名称
        customerserial: "",//下级门店编码
        notContainChild:false,//不包含下级门店
        childCustomerList:[],//下级门店列表
        form: {  //表单数据
          unitguid: '',
          discount: 0,//已完成额的差价
          pname: "",
          erpserial: "",
          htqd: "",
          jhjgrq: "",
          htje: "",//签订的合同总额
          remark: "",
          formtype: 41,
          customername: "",
          customerserial: "",
          parenterpserial: "",//关联上游合同
          parentguid: ""//关联上游合同
        },
        ftype: [
          {
            value: '40',
            name: "数量选择"
          },
          {
            value: '10',
            name: "现片"
          },
          {
            value: '20',
            name: "定制"
          },
          {
            value: '50',
            name: "加工"
          },
          {
            value: '60',
            name: "特殊加工"
          },
          {
            value: '30',
            name: "区分左右眼"
          },
        ],
      }
    },
    methods: {
      showRecordList() {
        this.$refs.DiffRecordList.show(this.form.erpserial, this.customerserial?this.customerserial:this.notContainChild?this.form.customerserial:"")
      },
      clearCustomer() {
        this.afterSelExternalDept("", "")
      },
      //选择门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.canRebateMoney = 0
        this.haveFinishMoney = 0
        this.needFinishMoney = 0
        this.tableData = []
        this.tableDataSkim = []
        this.tableDataChild = []
        this.bindData()
      },
      //查看订单
      handleViewOrder(index, row) {
        let time = [];
        time.push(this.form.htqd)
        time.push(this.form.jhjgrq)
        let categorycode = ''
        let categoryname = ''
        if (!row.seedcode) {
          categorycode = row.categorycode
          categoryname = row.categoryname
        }

        this.$refs.StoreDetailListSeedSee.initData(row, time, "20", 'all', categorycode, categoryname, this.form.customerserial);
        this.$refs.StoreDetailListSeedSee.show();
      },
      //查看子合同
      handleViewChildContract(index, row) {
        this.$refs.SaleContractEdit.initData(row.unitguid, false)
      },
      //获取下单方式名称
      getFilltemplate(filltemplate) {
        for (let i in this.ftype) {
          if (this.ftype[i].value == filltemplate) {
            return this.ftype[i].name
          }
        }
      },
      //计算差价
      calculateNewMoney() {
        this.$confirm("是否确定计算差价？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          calculateNewMoney({
            unitguid: this.form.unitguid,
            isChildContract: this.form.parenterpserial ? '1' : '0',
            customerserial: this.customerserial,
          }).then(response => {
            if(response.data.code==0) {
              this.bindData()
            }else{
              this.$message({
                type: 'error',
                duration: 3000,
                message: response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 3000,
            message: '已取消'
          });
        });
      },
      //绑定数据
      bindData() {
        this.canRebateMoney = 0
        this.haveFinishMoney = 0
        this.tableData = []
        this.tableDataSkim = []
        this.tableDataChild = []
        getTJByUnitGuid({
          unitguid: this.form.unitguid,
          isChildContract: this.form.parenterpserial ? '1' : '0',
          customerserial: this.customerserial?this.customerserial:this.notContainChild?this.form.customerserial:""
        }).then(response => {
          if (this.form) {
            for (let i in this.form) {
              this.form[i] = response.data.obj.form[i]
            }
          }
          this.getChildCustomer()//绑定下级门店
          //明细
          response.data.obj.detail.forEach(o => {
            if (o.isskim == 1) {
              this.tableDataSkim.push(o)
            } else {
              this.tableData.push(o)
            }
          })
          this.tableDataChild = response.data.obj.childcontract
          this.getTJMoney()
        });
      },
      //初始化
      initData(row) {
        this.initForm()
        this.dialogFormVisible = true
        this.form.parenterpserial = row.parenterpserial || ""
        if (row.parenterpserial) {
          this.title = '促销协议统计'
        } else {
          this.title = '合同信息统计'
        }
        //绑定数据
        this.form.unitguid = row.unitguid
        this.form.parenterpserial = row.parenterpserial
        this.bindData()
      },
      //获取统计数据
      getTJMoney() {
        let salemoney1 = 0, rebate1 = 0, salemoney2 = 0, rebate2 = 0, salemoney3 = 0, rebate3 = 0
        this.tableData.forEach(o => {
          salemoney1 += o.totalmoneytax || 0
          rebate1 += o.rebatemoney || 0
          this.canRebateMoney += o.rebatemoney || 0
          this.haveFinishMoney += o.totalmoneytax || 0
        })
        this.tableDataSkim.forEach(o => {
          salemoney2 += o.totalmoneytax || 0
          rebate2 += o.rebatemoney || 0
          if (o.iscontractmoney == 1) {
            this.haveFinishMoney += o.totalmoneytax || 0
          }
          this.canRebateMoney += o.rebatemoney || 0
        })
        this.tableDataChild.forEach(o => {
          salemoney3 += o.yfk || 0
          rebate3 += o.htje || 0
          if (o.returntype == 1) {
            this.haveFinishMoney += o.yfk || 0
          }
        })

        if (this.haveFinishMoney < this.form.htje) {//已完成额 去比较
          this.canRebateMoney = 0
        }

        this.tableData.push({categoryname: '合计', totalmoneytax: salemoney1, rebatemoney: rebate1})
        this.tableDataSkim.push({categoryname: '合计', totalmoneytax: salemoney2, rebatemoney: rebate2})
        this.tableDataChild.push({pname: '合计', yfk: salemoney3, htje: rebate3})

        let days = (new Date(this.form.jhjgrq).getTime() - new Date(this.form.htqd).getTime()) / (24 * 3600 * 1000) + 1
        let days2 = Math.floor((new Date().getTime() - new Date(this.form.htqd).getTime()) / (24 * 3600 * 1000)) + 1
        if (days2 > days) {
          days2 = days
        }
        this.needFinishMoney = this.form.htje * days2 / days  // 应完成额
        // let percent = Math.round(10000 * this.haveFinishMoney / this.needFinishMoney) / 100
        // this.percentage = this.needFinishMoney == 0 || percent >= 100 ? 100 : percent
        let percent = Math.round(10000 * this.haveFinishMoney / this.form.htje) / 100
        this.percentage = this.form.htje == 0 || percent >= 100 ? 100 : percent
      },

      getChildCustomer(){
        getListData({
          unitgroup: 1,
          parentcustomerserial:this.form.customerserial,
        }).then(response => {
          this.childCustomerList = response.data.obj.rows
        }).catch((error) => {
        });
      },

      //初始化数据
      initForm() {
        this.title = ""
        this.form.unitguid = ""
        this.tableData = []
        this.tableDataSkim = []
        this.tableDataChild = []
        this.form.customerserial = ""
        this.form.customername = ""
        this.form.parentguid = ""
        this.form.parenterpserial = ""
        this.form.discount = 0
        this.form.htje=""
        this.form.htqd=""
        this.form.jhjgrq=""
        this.canRebateMoney = 0
        this.haveFinishMoney = 0
        this.needFinishMoney = 0
        this.customerserial = ""
        this.customername = ""
        this.notContainChild=false
        this.childCustomerList=[]
      }

    },

    mounted() {
    },
    components: {
      SaleContractEdit,
      StoreDetailListSeedSee,
      DiffRecordList
    }

  }


</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .lefttitle {
    display: inline-block;
    width: 60px;
    text-align: right;
  }

  .rightinfo {
    width: 80px;
    display: inline-block;
  }
</style>




// WEBPACK FOOTER //
// src/components/testorder/salecontract/SaleContractTJ.vue